import { put } from 'redux-saga/effects'
import { fetchChatsInformationAction } from '../../handles'
import { fetchChatsInformation, FetchChatsInformationResponse } from '../_http/chat'

export function* fetchChatsInformationSaga(action: ReturnType<typeof fetchChatsInformationAction.request>) {
  const { campaignIds, departmentId, ownerId, filters, operatorId } = action.payload
  try {
    const response: FetchChatsInformationResponse = yield fetchChatsInformation({
      ownerId,
      campaignIds,
      departmentId,
      operatorId,
      filters
    })
    yield put(
      fetchChatsInformationAction.success({
        informations: response.chatsInformation
      })
    )
  } catch (error) {
    console.log({ fetchChatsInformationSagaError: error })
    yield put(fetchChatsInformationAction.failure(error))
  }
}
